// index.js
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  ReactDOM.render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>,
    document.getElementById("root")
  );
});
